import { useCallback, useMemo } from 'react';
import {
	ToothPathology,
	ToothPathologyToothWear,
} from '../../../../../graphql/graphql';
import useToothPathologyToothWearAbrasion from './useToothPathologyToothWearAbrasion';
import useToothPathologyToothWearSurfaces from './useToothPathologyToothWearSurfaces';

export default function useToothPathologyToothWear({
	pathology,
	setPathology,
}: {
	pathology?: ToothPathology;
	setPathology: (pathology: ToothPathology) => void;
}) {
	const setToothWear = useCallback(
		(toothWear: ToothPathologyToothWear) => {
			setPathology({
				...pathology,
				toothWear,
			});
		},
		[pathology, setPathology],
	);

	const toothWearProps = {
		toothWear: pathology?.toothWear,
		setToothWear,
	};

	const { abrasion } = useToothPathologyToothWearAbrasion(toothWearProps);
	const { erosion } = useToothPathologyToothWearSurfaces(
		'erosion',
		toothWearProps,
	);
	const { attrition } = useToothPathologyToothWearSurfaces(
		'attrition',
		toothWearProps,
	);
	const { abfraction } = useToothPathologyToothWearSurfaces(
		'abfraction',
		toothWearProps,
	);

	return useMemo(
		() => ({
			toothWear: {
				abrasion,
				erosion,
				attrition,
				abfraction,
			},
		}),
		[pathology],
	);
}
